<script>
  import { tokenDetailStore } from "../../../stores/tokenStore";
  import { projectDetailStore } from "../../../stores/projectStore";
  import { ethers } from "ethers";
  import { signerAddress, chainId } from "svelte-ethers-store";
  import Input from "../input-design/Input.svelte";
  import FormPanel from "../input-design/FormPanel.svelte";
  import { formattedChainID, getCurrentDate} from "../../../utils";
  import ReserveTokenDropDown from "../../../components/reserveToken-dropdown/ReserveTokenDropDown.svelte";
  import DeployModal from "./DeployModal.svelte";


  import {
    projectSaleStore,
    initialSaleDetail,
  } from "../../../stores/saleStore";

  import {createEventDispatcher, getContext} from "svelte";
  import { replace } from "svelte-spa-router";
  import { isLoaderActive } from "../../../store";
  import { validateField } from "../../../utils";
  import SelectChainDropDown from "../../../components/selectChain-dropdown/SelectChainDropDown.svelte";

  const { open, close } = getContext("simple-modal");
  
  const dispatch = createEventDispatcher();

  let saleDeploy = getContext("saleDeploy");
  let saleInitialValues;

  let tokenDetail, poolSize;
  let reserveErc20;
  let dropDownArrow = "./images/down-arrow.svg";
  let errors = (saleInitialValues = initialSaleDetail());
  let fields = {
    ...saleInitialValues,
    recipient: $signerAddress,
    reserveToken: "",
    coolDownDuration: "1",
    raiseTarget: "",
    capPerWallet: $tokenDetailStore.initialSupply,
  };

  let localStartDate = "",
    localEndDate = "",
    localStartTime = "",
    localEndTime = "";

  tokenDetailStore.subscribe((value) =>{
    if(!value) return
    tokenDetail = value;
    poolSize = tokenDetail.initialSupply * tokenDetail.projectTokenPrice;
    fields.raiseTarget = `${poolSize}`;
  });
  projectSaleStore.subscribe((value) => {
    fields = {
      ...value,
      recipient: value.recipient ? value.recipient : fields.recipient,
      reserveToken: value.reserveToken ? value.reserveToken : fields.reserveToken,
      coolDownDuration: value.coolDownDuration
        ? value.coolDownDuration
        : fields.coolDownDuration,
      raiseTarget: value.raiseTarget ? value.raiseTarget : fields.raiseTarget,
      capPerWallet: value.capPerWallet
        ? value.capPerWallet
        : fields.capPerWallet
    };
    if (fields.startDateAndTime) {
      let date = new Date(fields.startDateAndTime).toISOString();
      localStartDate = date.substring(0, 10);
      localStartTime = date.substring(11, 16);
    }

    if (fields.endDateAndTime) {
      let date = new Date(fields.endDateAndTime).toISOString();
      localEndDate = date.substring(0, 10);
      localEndTime = date.substring(11, 16);
    }
  })();
  const saveProject = getContext("save-project");
  const saveFormInDraft = async () => {
    if ($isLoaderActive) return;
    isLoaderActive.set(true);
    if (localStartDate && localStartTime)
      fields.startDateAndTime = new Date(
        `${localStartDate}T${localStartTime}:00.000Z`
      ).getTime();

    if (localEndDate && localEndTime)
      fields.endDateAndTime = new Date(
        `${localEndDate}T${localEndTime}:00.000Z`
      ).getTime();

    await saveProject(fields);
    isLoaderActive.set(false);
    replace("/sale-listing");
  };
 
  const validateSaleDetailForm = () => {
    let valid = true;

    errors.recipient = validateField(
      fields.recipient,
      "Recipient address",
      (field) => !ethers.utils.isAddress(field)
    );
    errors.reserveToken = validateField(
      fields.reserveToken,
      "Reserve token",
      (field) => !ethers.utils.isAddress(field)
    );
    errors.raiseTarget = validateField(fields.raiseTarget, "Raise target");
    errors.capPerWallet = validateField(fields.capPerWallet, "Cap per wallet")
    valid = !(
      errors.recipient ||
      errors.reserveToken ||
      errors.raiseTarget ||
      errors.capPerWallet
    );

    if (
      fields.raiseTarget.trim() < 0 ||
      isNaN(fields.raiseTarget) ||
      Number(fields.raiseTarget) > poolSize
    ) {
      valid = false;
      errors.raiseTarget =
        fields.raiseTarget > poolSize
          ? "Raise target should not be greater then pool value"
          : "Raise target should be integer and greater than 0";
    }

    if (
      fields.capPerWallet.trim() < 0 ||
      isNaN(fields.capPerWallet) ||
      Number(fields.capPerWallet) > Number(tokenDetail.initialSupply)
    ) {
      valid = false;
      errors.capPerWallet =
        Number(fields.capPerWallet) > Number(tokenDetail.initialSupply)
          ? "Cap per wallet should not be greater then total supply"
          : "Cap per wallet should be integer and greater than 0";
    }

    let currentDate = new Date();
    fields.startDateAndTime = new Date(
      `${localStartDate}T${localStartTime}:00.000Z`
    ).getTime();

    fields.endDateAndTime = new Date(
      `${localEndDate}T${localEndTime}:00.000Z`
    ).getTime();

    if (!localStartDate || !localStartTime ) {
      valid = false;
      errors.startDateAndTime = "Select start date and time";
    }

    if (!localEndDate || !localEndTime) {
      valid = false;
      errors.endDateAndTime = "Select end date and time";
    }

    if (currentDate.getTime() > fields.startDateAndTime) {
      valid = false;
      errors.startDateAndTime = "Start time should be greater than now";
    }

    if (fields.startDateAndTime >= fields.endDateAndTime) {
      valid = false;
      errors.endDateAndTime = "End time should be greater than now";
    }

    if (!valid) {
      window.scroll({ top: 0 });
      return false;
    }

    errors = initialSaleDetail();
    projectSaleStore.setProjectSaleDetail({ ...fields });
    return true;
  };

  const deploySale = () => {
    close();
    deploy();
  }

  const handleSale = () => {
    if (validateSaleDetailForm()) {
      open(DeployModal, { deploySale});
    }
  };

  let saleDeploying = false;
  let deployError = "";

  const deploy = async () => {
    if (!reserveErc20) {
      window.scroll({ top: 0 });
      return (errors.reserveToken = "Reserve token has not been loaded yet.");
    }

    saleDeploying = true;
    deployError = "";

    let chainID = formattedChainID($chainId);


    await saveProject(fields);

    try {
      let sale = await saleDeploy(
        fields.recipient,
        fields.reserveToken,
        parseInt(fields.coolDownDuration),
        Number(fields.raiseTarget),
        Number(tokenDetail.projectTokenPrice),
        tokenDetail.tokenName,
        tokenDetail.tokenSymbol,
        Number(tokenDetail.initialSupply),
        Number(fields.capPerWallet),
        Math.floor(fields.startDateAndTime / 1000),
        Math.floor(fields.endDateAndTime / 1000),
        reserveErc20,
      );

      await saveProject(fields, sale.address, chainID);

      saleDeploying = false;
      replace("/sale-listing");
    } catch (error) {
      deployError = error.message;
      saleDeploying = false;
    }
  };

  const modalAction = () => {
    if (validateSaleDetailForm()) {
      dispatch("modalAction");
    }
  };

  let crossModal = "./images/cross.svg";
  const backTop = () => {
    window.scroll({ top: 0 });
  };
</script>

<section>
  <FormPanel>
    <div class="flex flex-wrap form-row items-end">
      <div class="col-6">
        <Input
                bind:value={fields.recipient}
                on:input={() => (errors = { ...errors, recipient: "" })}
                id="recipient"
        >
          <label for="recipient" slot="label" class="form-label">
            Recipient
            <small>*</small>
          </label>
          <span slot="label_dec" class="form-label-dec">Wallet address for funds to be received <small class="d-block">please ensure wallet address is correct - incorrect address will result in lost funds</small>
          </span>
        </Input>
        <div class="error">{errors.recipient}</div>
      </div>
      <div class="col-6">
        <SelectChainDropDown
                {dropDownArrow}
        />
      </div>
    </div>
    <div class="flex flex-wrap form-row items-start">
      <div class="col-12">
        <ReserveTokenDropDown
          bind:selectedAddress = {fields.reserveToken}
          {dropDownArrow}
          bind:reserveErc20={reserveErc20}
          {errors}
        />
        <div class="error">{errors.reserveToken}</div>
      </div>
      <div class="col-6">
        <div class="input-title column-direction flex">
          <label for="" class="form-label">
            Start Date Time (UTC)
            <small>*</small>
          </label>
          <span class="form-label-dec">
            Date your project raise will start
          </span>
        </div>
        <div class="sub-row">
          <div class="col-7">
            <input
              type="date"
              id="p-start-date"
              class="date-input form-input"
              data-date-format="YYYY MMMM DD"
              min={getCurrentDate()}
              max="9999-12-31"
              bind:value={localStartDate}
              on:input={() => (errors = { ...errors, startDateAndTime: "" })}
            />
          </div>
          <div class="col-5">
            <input
              type="time"
              id="p-start-time"
              class="form-input"
              bind:value={localStartTime}
              on:input={() => (errors = { ...errors, startDateAndTime: "" })}
            />
          </div>
        </div>
        <div class="error">{errors.startDateAndTime}</div>
      </div>
      <div class="col-6">
        <div class="input-title column-direction flex">
          <label for="" class="form-label">
            End Date Time (UTC)
            <small>*</small>
          </label>
          <span class="form-label-dec">Date your project raise will end</span>
        </div>
        <div class="sub-row">
          <div class="col-7">
            <input
              type="date"
              id="p-end-date"
              class="date-input form-input"
              data-date-format="YYYY MMMM DD"
              bind:value={localEndDate}
              min={getCurrentDate()}
              max="9999-12-31"
              on:input={() => (errors = { ...errors, endDateAndTime: "" })}
            />
          </div>
          <div class="col-5">
            <input
              type="time"
              id="p-end-time"
              class="form-input"
              bind:value={localEndTime}
              on:input={() => (errors = { ...errors, endDateAndTime: "" })}
            />
          </div>
        </div>
        <div class="error">{errors.endDateAndTime}</div>
      </div>
    </div>
    <div class="bottom-fields flex flex-wrap form-row items-end">
      <div class="col-6">
        <Input
          bind:value={fields.raiseTarget}
          on:input={() => (errors = { ...errors, raiseTarget: "" })}
          id="config-raise-target"
        >
          <label for="config-raise-target" slot="label" class="form-label">
            Raise Target
            <small>*</small>
          </label>
          <span slot="label_dec" class="form-label-dec">
            How much do you wish to raise?
          </span>
        </Input>
        <div class="error">{errors.raiseTarget}</div>
      </div>
      <div class="col-6">
        <Input
          bind:value={fields.capPerWallet}
          on:input={() => (errors = { ...errors, capPerWallet: "" })}
          id="cap-per-wallet"
        >
          <label for="cap-per-wallet" slot="label" class="form-label">
            Cap Per Wallet (Individual purchase limit)
            <small>*</small>
          </label>
          <span slot="label_dec" class="form-label-dec">
            What limit do you want to set for any individual to purchase if any.
          </span>
        </Input>
        <div class="error">{errors.capPerWallet}</div>
      </div>
    </div>
  </FormPanel>
</section>
<section>
  <div class="flex flex-wrap form-row items-end">
    <div class="col-12">
      <span class="form-label-dec m-0"
        >If set to anything other than the zero address, all unsold rTKN will be
        forwarded to this address at the end of the raise. If the minimum raise
        is 0, this must be set to something other than the zero address.</span
      >
    </div>
  </div>
</section>
<section>
  <div class="flex flex-wrap form-row items-end">
    <div class="col-12">
      <label for="" class="form-label">Eligibility:</label>
      <br />
      <span class="form-label-dec">There is no tier gating for this sale.</span>
    </div>
  </div>
</section>
<div class="pl-button-wrapper">
  <button
    class="pl-button pl-clear-btn"
    id="sale-config-back"
    on:click={backTop}
    on:click={() => dispatch("back")}
  >
    Back
  </button>
  <button
    disabled={saleDeploying}
    class="pl-button pl-draft-btn"
    id="sale-config-save"
    on:click={saveFormInDraft}
  >
    Save
  </button>
  <button
    class="pl-button pl-preview-btn"
    id="sale-config-preview"
    on:click={modalAction}
  >
    Preview
  </button>
  <button
    class="pl-button relative pl-next-btn {saleDeploying ? 'disable' : ''}"
    id="sale-deploy"
    on:click={handleSale}
  >
    Deploy Sale
    {#if saleDeploying}
      <img class="btn-load" src="./images/btn-load.gif" alt="loader img" />
    {/if}
  </button>
</div>
{#if deployError}
  <div class="pl-modal deployerror-msd">
    <div class="pl-modal-dialog flex items-center">
      <div class="pl-modal-content flex column-direction">
        <img
          src={crossModal}
          on:click={() => (deployError = "")}
          alt="Cross Button"
        />
        {deployError}
      </div>
    </div>
  </div>
{/if}
